import { Box, Button, CopyButton, Group } from "@mantine/core"
import React from "react"
import SyntaxHighlighter from "react-syntax-highlighter"

interface Props {
  code: string
  language?: string
}

const TagCodeBlock: React.FC<Props> = ({ code, language = 'javascript' }) => {
  return (
    <Box>
      <SyntaxHighlighter
        language={language}
        customStyle={{ borderRadius: 5, margin: 0 }}
      >
        {code}
      </SyntaxHighlighter>
      <Group justify="start" mt={12}>
        <CopyButton value={code} timeout={2000}>
          {({ copied, copy }) => (
            <Button
              onClick={copy}
              variant="filled"
              color={copied ? 'gray' : 'invy'}
              radius="xl"
              fw={600}
            >
              {copied ? 'コピー済み' : 'コピー'}
            </Button>
          )}
        </CopyButton>
      </Group>
    </Box>
  )
}

export default TagCodeBlock
